import React from 'react';

import { IAuthor } from '../../../../types/author';

/**
 * Микроразметка для автора
 */
export const AuthorMicrodata = ({
  name,
  url,
  image,
  jobTitle,
  description,
  gender,
  email,
  worksFor,
  sameAs,
  alumniOf,
  knowsAbout,
  hasCredential,
  award,
}: IAuthor) => {
  return (
    <div itemProp="author" itemScope itemType="https://schema.org/Person">
      {name && <meta itemProp="name" content={name} />}
      {url && <meta itemProp="url" content={url} />}
      {image && <meta itemProp="image" content={image} />}
      {jobTitle && <meta itemProp="jobTitle" content={jobTitle} />}
      {description && <meta itemProp="description" content={description} />}
      {gender && <meta itemProp="gender" content={gender} />}
      {email && <meta itemProp="email" content={email} />}
      {worksFor && <meta itemProp="worksFor" content={worksFor} />}
      {sameAs && <meta itemProp="sameAs" content={sameAs} />}
      {alumniOf && <meta itemProp="alumniOf" content={alumniOf} />}
      {knowsAbout && <meta itemProp="knowsAbout" content={knowsAbout} />}
      {hasCredential && <meta itemProp="hasCredential" content={hasCredential} />}
      {award && <meta itemProp="award" content={award} />}
    </div>
  );
};
